














































































































































































































































































































































































import BaseFilter from "@/components/Filter/BaseFilter";
import {PushDetailFilterParams} from "@/store/push/statistic/types";
import {Component, PropSync, Watch} from "vue-property-decorator";
import {DatePickerWings,
  FastDateDetailWings,
  SelectWings,
  NumberWings,
  InputWings
} from "wings-ui-components";
import {beginningOfCurrentDay, currentDateEnd, dateFilter} from "@/utils/date-util";
import {Action, Getter} from "vuex-class";
import {notifyError, notifyWarning} from "@/utils/notify-helper";
import { MsgTransports } from '@/store/types';
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({
  components: {
    FastDateDetailWings,
    DatePickerWings,
    SelectWings,
    NumberWings,
    InputWings
  },
  filters: {dateFilter}
})
export default class PushDetailFilter extends BaseFilter<PushDetailFilterParams> {
  @PropSync("showAdditional") is_show_additional!: boolean;
  @PropSync("filterClone") propFilterClone!: PushDetailFilterParams;
  @PropSync("runFilter") propRunFilter!: boolean;

  @Getter("pushApplications") applicationsList!: any[];
  @Getter("pushOS") pushOSList!: string[];
  @Getter("messageTypes") messageTypesList: any;
  @Getter("pushMessagesStatusList") statusList: any;

  @Action("getPushStatisticDetail") actionGetItems: any;
  @Action("exportPushStatisticDetail") actionExport: any;
  @Action("getPushApplications") actionGetPushApplications: any;
  @Action("getPushOS") actionGetPushOS: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getPartnerUsers") actionGetPartnerUsers: any;
  @Action("getOriginators") actionGetOriginators: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("getAccounts") actionGetAccounts: any;
  @Action("getMessageTypes") actionGetMessageTypes: any;
  @Action("actionLog") actionLog: any;

  defaultFilter(): PushDetailFilterParams {
    return new PushDetailFilterParams(beginningOfCurrentDay(), currentDateEnd());
  }

  params = {transport: MsgTransports.PUSH};
  partnersList: any = []
  accountsList: any = []
  partnerUsersList: any = []
  partnerUsersEmailList: any = []

  filterKeys: object = {
    "originator" : "addresser",
    "recipient" : "receiver",
    "broker_account_login" : "account",
    "transport_message_id" : "smpp_message_id",
    "partner_user_login": "partner_login"
  }

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getAccountsList(filter: any) {
    const items = await this.actionGetAccounts({...this.params, ...filter});
    this.accountsList = (filter?.page_number > 1) ? this.accountsList.concat(items) : items
  }

  async getPartnerUsersList(filter: any) {
    if (this.filter.partner) filter = {...filter, partner: this.filter.partner}
    const items = await this.actionGetPartnerUsers({...this.params, ...filter});
    this.partnerUsersList = (filter?.page_number > 1) ? this.partnerUsersList.concat(items) : items
  }

  async getPartnerUsersEmailList(filter: any) {
    if (this.filter.partner) filter = {...filter, partner: this.filter.partner}
    const items = await this.actionGetPartnerUsers({...this.params, ...filter});
    this.partnerUsersEmailList = (filter?.page_number > 1) ? this.partnerUsersEmailList.concat(items) : items
  }

  async created() {
    try {
      this.actionGetPushApplications();
      this.actionGetMessageTypes();
      this.actionGetPushOS();
      this.scroll()
    } catch (err) {
      notifyError(err);
    }
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
    if (this.filter.broker_account_login) this.accountsList = await this.actionGetAccounts({login: this.filter.broker_account_login});
    if (this.filter.partner_user_login) this.partnerUsersList = await this.actionGetPartnerUsers({email: this.filter.partner_user_login});
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Detail statistics",
        addititional_info: getTranslatedParams(this.filter, this.filterKeys)
      };
      const resp = await this.actionGetItems(this.filter);
      await this.actionLog(this.logObject);
      if (resp.status == 204) {
        this.is_last = true
        if (!nextPage) notifyWarning()
      } else {
        this.is_last = false
      }
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    } finally {
      this.moreLoading = false;
    }
  }

  async doActionExport(filter: PushDetailFilterParams): Promise<any> {
    return await this.actionExport(filter);
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChange(val: PushDetailFilterParams) {
    this.propFilterClone = val;
  }

  @Watch('runFilter', {immediate: true})
  onRunFilterChange(val: boolean) {
    if (val) {
      this.filtered();
      this.propRunFilter = false;
    }
  }
}
